const loginConstants = {
  LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USER_LOGIN_FAILUTE',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
};

export default loginConstants;
